<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Impresoras M3250, MS622">
     Impresoras M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_es" title="Informaci&oacute;n de seguridad">
     Informaci&oacute;n de seguridad
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenciones">
      Convenciones
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Instrucciones del producto">
      Instrucciones del producto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_es" title="Informaci&oacute;n acerca de la impresora">
     Informaci&oacute;n acerca de la impresora
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_es" title="B&uacute;squeda de informaci&oacute;n sobre la impresora">
      B&uacute;squeda de informaci&oacute;n sobre la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_es" title="Selecci&oacute;n de ubicaci&oacute;n para la impresora">
      Selecci&oacute;n de ubicaci&oacute;n para la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_es" title="Configuraciones de la impresora">
      Configuraciones de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_es" title="Conexi&oacute;n de cables">
      Conexi&oacute;n de cables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_es" title="Uso del panel de control">
      Uso del panel de control
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_es" title="Descripci&oacute;n del estado del bot&oacute;n de encendido e indicador luminoso">
      Descripci&oacute;n del estado del bot&oacute;n de encendido e indicador luminoso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_es" title="Impresi&oacute;n de la p&aacute;gina de configuraci&oacute;n de la red">
      Impresi&oacute;n de la p&aacute;gina de configuraci&oacute;n de la red
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_es" title="Configuraci&oacute;n y uso de las aplicaciones de la pantalla de inicio">
     Configuraci&oacute;n y uso de las aplicaciones de la pantalla de inicio
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_es" title="Uso de la pantalla de inicio">
      Uso de la pantalla de inicio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_es" title="Personalizaci&oacute;n de la pantalla de inicio">
      Personalizaci&oacute;n de la pantalla de inicio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_es" title="Personalizaci&oacute;n de la pantalla, uso">
      Personalizaci&oacute;n de la pantalla, uso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_es" title="Configuraci&oacute;n de Valores eco">
      Configuraci&oacute;n de Valores eco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_es" title="Uso del servicio de atenci&oacute;n al cliente">
      Uso del servicio de atenci&oacute;n al cliente
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_es" title="Utilizaci&oacute;n del generador de c&oacute;digos QR">
      Utilizaci&oacute;n del generador de c&oacute;digos QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_es" title="Configuraci&oacute;n de cuotas de dispositivos">
      Configuraci&oacute;n de cuotas de dispositivos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_es" title="Creaci&oacute;n de un perfil de Conector en la nube">
      Creaci&oacute;n de un perfil de Conector en la nube
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1094" title="Administraci&oacute;n de marcadores">
      Administraci&oacute;n de marcadores
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1171" title="Gesti&oacute;n de contactos">
      Gesti&oacute;n de contactos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_es" title="Configuraci&oacute;n y uso del software de las funciones de accesibilidad">
     Configuraci&oacute;n y uso del software de las funciones de accesibilidad
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_es" title="Activaci&oacute;n de la navegaci&oacute;n por voz">
      Activaci&oacute;n de la navegaci&oacute;n por voz
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_es" title="Desplazamiento por la pantalla usando gestos">
      Desplazamiento por la pantalla usando gestos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_es" title="activaci&oacute;n del modo de ampliaci&oacute;n">
      activaci&oacute;n del modo de ampliaci&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_es" title="Ajuste de la velocidad de voz en la navegaci&oacute;n por voz">
      Ajuste de la velocidad de voz en la navegaci&oacute;n por voz
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_es" title="Uso del teclado en la pantalla">
      Uso del teclado en la pantalla
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_es" title="Activaci&oacute;n de contrase&ntilde;as por voz o n&uacute;meros de identificaci&oacute;n personal">
      Activaci&oacute;n de contrase&ntilde;as por voz o n&uacute;meros de identificaci&oacute;n personal
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_es" title="Carga de papel y material especial">
     Carga de papel y material especial
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_es" title="Definici&oacute;n del tipo y el tama&ntilde;o del papel">
      Definici&oacute;n del tipo y el tama&ntilde;o del papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_es" title="Configuraci&oacute;n del valor de papel Universal">
      Configuraci&oacute;n del valor de papel Universal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_es" title="Carga de bandejas">
      Carga de bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_es" title="Carga del alimentador multiuso">
      Carga del alimentador multiuso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_es" title="Enlace de Bandejas">
      Enlace de Bandejas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_es" title="Soporte de papel">
     Soporte de papel
    </a>
   </p>
   <div id="divd0e1663">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_es" title="Tama&ntilde;os de papel admitidos">
      Tama&ntilde;os de papel admitidos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_es" title="Tipos de papel admitidos">
      Tipos de papel admitidos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_es" title="Pesos de papel admitidos">
      Pesos de papel admitidos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_es" title="Papel no recomendado">
      Papel no recomendado
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_es" title="Uso de papel reciclado">
      Uso de papel reciclado
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_es" title="Impresi&oacute;n">
     Impresi&oacute;n
    </a>
   </p>
   <div id="divd0e2522">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_es" title="Impresi&oacute;n desde un ordenador">
      Impresi&oacute;n desde un ordenador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2548" title="Impresi&oacute;n desde un dispositivo m&oacute;vil">
      Impresi&oacute;n desde un dispositivo m&oacute;vil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_es" title="Impresi&oacute;n desde una unidad flash">
      Impresi&oacute;n desde una unidad flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_es" title="Unidades flash y tipos de archivo admitidos">
      Unidades flash y tipos de archivo admitidos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_es" title="Configuraci&oacute;n de trabajos confidenciales">
      Configuraci&oacute;n de trabajos confidenciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_es" title="Impresi&oacute;n de trabajos confidenciales y otros trabajos en espera">
      Impresi&oacute;n de trabajos confidenciales y otros trabajos en espera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_es" title="Impresi&oacute;n desde un perfil de Conector en la nube">
      Impresi&oacute;n desde un perfil de Conector en la nube
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_es" title="Impresi&oacute;n de una lista de muestra de fuentes">
      Impresi&oacute;n de una lista de muestra de fuentes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_es" title="Impresi&oacute;n de una lista de directorio">
      Impresi&oacute;n de una lista de directorio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_es" title="Cancelaci&oacute;n de un trabajo de impresi&oacute;n">
      Cancelaci&oacute;n de un trabajo de impresi&oacute;n
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_es" title="Descripci&oacute;n de los men&uacute;s de la impresora">
     Descripci&oacute;n de los men&uacute;s de la impresora
    </a>
   </p>
   <div id="divd0e3060">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_es" title="Mapa de men&uacute;s">
      Mapa de men&uacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3379" title="Dispositivo">
      Dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5225" title="Impresi&oacute;n">
      Impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6483" title="Papel">
      Papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6745" title="Unidad USB">
      Unidad USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6966" title="Red/Puertos">
      Red/Puertos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8756" title="Seguridad">
      Seguridad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9891" title="Informes">
      Informes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_es" title="Ayuda">
      Ayuda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10138" title="Soluci&oacute;n de problemas">
      Soluci&oacute;n de problemas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_es" title="Impresi&oacute;n de la p&aacute;gina de valores de men&uacute;">
      Impresi&oacute;n de la p&aacute;gina de valores de men&uacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_es" title="Asegurar la impresora">
     Asegurar la impresora
    </a>
   </p>
   <div id="divd0e10190">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_es" title="Localizaci&oacute;n de la ranura de seguridad">
      Localizaci&oacute;n de la ranura de seguridad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_es" title="Borrado de memoria de la impresora">
      Borrado de memoria de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_es" title="Borrado de la memoria del disco duro de la impresora">
      Borrado de la memoria del disco duro de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_es" title="Codificaci&oacute;n del disco duro de la impresora">
      Codificaci&oacute;n del disco duro de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_es" title="Restauraci&oacute;n de los valores predeterminados de f&aacute;brica">
      Restauraci&oacute;n de los valores predeterminados de f&aacute;brica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_es" title="Declaraci&oacute;n de volatilidad">
      Declaraci&oacute;n de volatilidad
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_es" title="Mantenimiento de la impresora">
     Mantenimiento de la impresora
    </a>
   </p>
   <div id="divd0e10404">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_es" title="Configuraci&oacute;n de alertas de correo">
      Configuraci&oacute;n de alertas de correo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_es" title="Ajuste del volumen predeterminado de los auriculares">
      Ajuste del volumen predeterminado de los auriculares
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10466" title="Conexi&oacute;n en red">
      Conexi&oacute;n en red
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_es" title="Configuraci&oacute;n de la impresi&oacute;n por puerto serie (solo Windows)">
      Configuraci&oacute;n de la impresi&oacute;n por puerto serie (solo Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_es" title="Limpieza de la impresora">
      Limpieza de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_es" title="Solicitud de suministros y piezas">
      Solicitud de suministros y piezas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11202" title="Sustituci&oacute;n de suministros y piezas">
      Sustituci&oacute;n de suministros y piezas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11346" title="Traslado de la impresora">
      Traslado de la impresora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11402" title="Ahorro de energ&iacute;a y papel">
      Ahorro de energ&iacute;a y papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11507" title="Reciclaje">
      Reciclaje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_es" title="Eliminaci&oacute;n de atascos">
     Eliminaci&oacute;n de atascos
    </a>
   </p>
   <div id="divd0e11540">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_es" title="C&oacute;mo evitar atascos">
      C&oacute;mo evitar atascos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_es" title="Identificaci&oacute;n de la ubicaci&oacute;n del atasco">
      Identificaci&oacute;n de la ubicaci&oacute;n del atasco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_es" title="Atasco de papel en la puerta A">
      Atasco de papel en la puerta A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_es" title="Atasco de papel en la puerta posterior">
      Atasco de papel en la puerta posterior
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_es" title="Atasco de papel en la bandeja est&aacute;ndar">
      Atasco de papel en la bandeja est&aacute;ndar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_es" title="Atasco de papel en la unidad de impresi&oacute;n a doble cara">
      Atasco de papel en la unidad de impresi&oacute;n a doble cara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_es" title="Atasco de papel en las bandejas">
      Atasco de papel en las bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_es" title="Atasco de papel en el alimentador multiuso">
      Atasco de papel en el alimentador multiuso
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_es" title="Soluci&oacute;n de problemas">
     Soluci&oacute;n de problemas
    </a>
   </p>
   <div id="divd0e11816">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11819" title="Problemas de conexi&oacute;n de red">
      Problemas de conexi&oacute;n de red
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12134" title="Problemas con las opciones de hardware">
      Problemas con las opciones de hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12409" title="Problemas con los suministros">
      Problemas con los suministros
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_es" title="Problemas de alimentaci&oacute;n del papel">
      Problemas de alimentaci&oacute;n del papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_es" title="Problemas de impresi&oacute;n">
      Problemas de impresi&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_es" title="Contacto con el servicio de atenci&oacute;n al cliente">
      Contacto con el servicio de atenci&oacute;n al cliente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_es" title="Actualizaci&oacute;n y migraci&oacute;n">
     Actualizaci&oacute;n y migraci&oacute;n
    </a>
   </p>
   <div id="divd0e15399">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15402" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15712" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15796" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_es" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e15882">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15885" title="Informaci&oacute;n de producto">
      Informaci&oacute;n de producto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15902" title="Nota sobre la edici&oacute;n">
      Nota sobre la edici&oacute;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_es" title="Marcas comerciales">
      Marcas comerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_es" title="Avisos de licencia">
      Avisos de licencia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_es" title="Niveles de emisi&oacute;n de ruido">
      Niveles de emisi&oacute;n de ruido
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_es" title="Directiva de residuos de aparatos el&eacute;ctricos y electr&oacute;nicos (WEEE)">
      Directiva de residuos de aparatos el&eacute;ctricos y electr&oacute;nicos (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16006" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_es" title="Informaci&oacute;n para el desecho de los productos">
      Informaci&oacute;n para el desecho de los productos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16040" title="Bater&iacute;a recargable de iones de litio">
      Bater&iacute;a recargable de iones de litio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_es" title="Normativa (UE) 2023/1542">
      Normativa (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_es" title="Devoluci&oacute;n de los cartuchos Lexmark para su reutilizaci&oacute;n o reciclado">
      Devoluci&oacute;n de los cartuchos Lexmark para su reutilizaci&oacute;n o reciclado
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_es" title="Aviso sobre sensibilidad est&aacute;tica">
      Aviso sobre sensibilidad est&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_es" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_es" title="Informaci&oacute;n acerca de la temperatura">
      Informaci&oacute;n acerca de la temperatura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#mexico-energy-information_es" title="Informaci&oacute;n de la energ&iacute;a de M&eacute;xico">
      Informaci&oacute;n de la energ&iacute;a de M&eacute;xico
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_es" title="Aviso de l&aacute;ser">
      Aviso de l&aacute;ser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_es" title="Consumo de energ&iacute;a">
      Consumo de energ&iacute;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16290" title="Avisos sobre normativa relativos a productos inal&aacute;mbricos">
      Avisos sobre normativa relativos a productos inal&aacute;mbricos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_es" title="Aviso sobre componentes modulares">
      Aviso sobre componentes modulares
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_es" title="Exposici&oacute;n a radiaci&oacute;n de radiofrecuencia">
      Exposici&oacute;n a radiaci&oacute;n de radiofrecuencia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16316" title="Para su uso en M&eacute;xico">
      Para su uso en M&eacute;xico
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16321" title="Conformidad con las directivas de la Comunidad Europea (CE)">
      Conformidad con las directivas de la Comunidad Europea (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_es" title="Conformidad con las directivas de la Comunidad Europea (CE)">
      Conformidad con las directivas de la Comunidad Europea (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_es" title="Aviso de interferencia de radio">
      Aviso de interferencia de radio
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue